import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Link, Navigate } from 'react-router-dom';

import { Button } from '@/app/components/ui/Button';
import { Spinner } from '@/app/components/ui/Spinner';
import { AuthScreen } from '@/features/auth/AuthScreen';
import { readReturnTo } from '@/features/auth/signinState';

/**
 * Where Keycloak sends the browser back to. `react-oidc-context` performs the
 * code exchange automatically on mount; this page just shows progress and, once
 * the user is in, returns them to the path stashed in the signin state.
 */
export function CallbackPage() {
  const { t } = useTranslation();
  const auth = useAuth();

  if (auth.isAuthenticated) {
    return <Navigate to={readReturnTo(auth.user?.state)} replace />;
  }

  if (auth.error) {
    return (
      <AuthScreen title={t('auth.signInFailed')}>
        <p className="text-ink text-sm">{auth.error.message}</p>
        <Button as={Link} to="/" variant="secondary" size="sm">
          {t('auth.backToDashboard')}
        </Button>
      </AuthScreen>
    );
  }

  return (
    <AuthScreen title={t('auth.signingIn')}>
      <Spinner />
    </AuthScreen>
  );
}
